<template>
  <form @submit.prevent="saveAddress">
    <div class="dialog-header">
      <h1>
        {{ custom.reference.label ? custom.reference.label : 'Referentie' }}
      </h1>
    </div>
    <div class="dialog-content">
      <form class="inp-container" @submit.prevent="saveReference">
        <project-input
          :fields="[
            {
              format: custom.reference.format || '',
              maxLength: custom.reference.maxLength || 30,
              placeholder: custom.reference.placeholder || 'max 30 karakters'
            }
          ]"
          @setProject="storeNewReference"
          :project-name="reference"
          class="input"
        ></project-input>

        <button
          class="pill-button add-button"
          type="submit"
          title="Project"
          :disabled="!reference"
        >
          Voeg toe
        </button>
      </form>
      <div class="list">
        <ul>
          <li
            v-for="(reference, index) in references"
            :key="reference.id"
            @click="selectReference(reference.value)"
            :class="{ active: reference === activeReference }"
          >
            <span> {{ reference.value }} </span>
            <remove-button
              v-if="reference.userId"
              @click.native="removeRef(reference, index)"
            ></remove-button>
          </li>
        </ul>
      </div>
    </div>
  </form>
</template>

<script>
import ProjectInput from '@/components/ProjectInput'
import RemoveButton from '@/components/ui/RemoveButton.vue'
import { saveReference, deleteReference } from '@/api/addressBookApi'
import { useAddressBookStore } from '@/stores/AddressBook.store'

export default {
  props: {
    setReference: Function,
    customerNumber: Number
  },
  components: {
    ProjectInput,
    RemoveButton
  },
  data() {
    return {
      reference: ''
    }
  },
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    },
    referenceRequired() {
      return !!this.custom.reference.required
    },
    activeReference() {
      return ''
    },
    references() {
      const addressBookStore = useAddressBookStore()
      const address = addressBookStore.invoiceAddresses.find(
        (address) => address.customerNumber === this.customerNumber
      )

      return address?.references?.toSorted() || []
    }
  },
  methods: {
    removeRef(reference) {
      const addressBookStore = useAddressBookStore()
      deleteReference(reference).then(() => {
        addressBookStore.deleteAddressReference(reference)
      })
    },
    storeNewReference(val) {
      this.reference = val
    },
    saveReference() {
      if (!this.reference) return
      const addressBookStore = useAddressBookStore()
      saveReference(this.customerNumber, { value: this.reference }).then(
        (reference) => {
          addressBookStore.addAddressReference(reference)
        }
      )

      this.setReference(this.reference)
      this.$emit('close')
    },
    selectReference(reference) {
      this.setReference(reference)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.inp-container {
  display: flex;
  align-items: center;

  .input {
    flex-grow: 1;
  }

  .add-button {
    margin-bottom: 10px;
    margin-left: 10px;
  }

  svg {
    width: 100%;
    height: 100%;

    :deep(circle) {
      fill: var(--sub-color);
    }
  }
}

li {
  padding: 10px 5px;
  text-align: left;
  border-radius: 20px;
  transition: 0.4s all;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    //    box-shadow: var(--default-shadow);
    font-weight: 600;
  }

  &.active {
    font-weight: 500;
  }

  span {
    flex-grow: 1;
  }

  button {
  }
}
</style>
